<template>
  <main class="network" id="branch">
    <section>
      <img :src="topImg" alt class="top-img" />
    </section>

    <!-- 战略版图 -->
    <section class="brand-box">
      <section class="brand total-width">
        <h1 class="black-title" id="origin">战略版图</h1>
        <div class="map-container">
          <!-- 主地图 -->
          <img
            class="img"
            :src="currentMap"
            alt="战略版图"
            @click="toggleThumbnail"
          />

          <!-- 左下角缩略图 -->
          <div
            class="thumbnail-minimap"
            :class="{ active: isThumbActive }"
            @mouseenter="isThumbActive = true"
            @mouseleave="isThumbActive = false"
          >
            <div class="thumbnail-mask">
              <img
                :src="isHover ? thumbnailMapHover : thumbnailMap"
                alt="缩略图"
                @mouseover="isHover = true"
                @mouseleave="isHover = false"
                @click.stop="switchMainMap"
              />
              <!--              <div class="hover-tip" v-show="isThumbActive">-->
              <!--                <span>点击切换地图</span>-->
              <!--                <div class="arrow"></div>-->
              <!--              </div>-->
            </div>
          </div>
        </div>
      </section>
    </section>

    <section>
      <div class="kk-content total-width">
        <h1 class="black-title" id="zsb">专升本培训全国分校</h1>
        <div class="wrap">
          <ul class="left">
            <li
              v-for="item in iList"
              :key="item.id"
              :class="{ 'n-active': nId === item.id }"
              @click="selectHandle(item.id)"
            >
              {{ item.province }}
            </li>
          </ul>
          <ul class="right">
            <li v-for="(item, index) in currentData" :key="index">
              <div class="top">
                <h2>
                  {{ item.title }}
                  <!-- <span class="title_logo" v-if="item.titleLogo" :style="{backgroundImage:`url(${item.titleLogo})`}"></span> -->
                </h2>
                <p class="address">分校地址：{{ item.address }}</p>
              </div>
              <div class="bottom">
                <p class="people" v-if="item.contacts">
                  联系人：<b>{{ item.contacts }}</b>
                </p>
                <p class="hot-line">
                  客服热线：<b>{{ item.hotLine }}</b>
                </p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </section>
    <!-- 

    <section>
      <div class="kk-content total-width">
        <h1 class="black-title" id="gz">公职培训全国分校</h1>
        <div class="wrap">
          <ul class="left">
            <li
                v-for="item in iListTwo"
                :key="item.id"
                :class="{'n-active':nIdTwo===item.id}"
                @click="selectHandleTwo(item.id)">{{item.province}}</li>
          </ul>
          <ul class="right">
            <li v-for="(item,index) in currentDateTwo" :key="index">
              <div class="top">
                <h2>{{item.title}}
                  <span class="title_logo" v-if="item.titleLogo" :style="{backgroundImage:`url(${item.titleLogo})`}"></span> 
                </h2>
                <p class="address">分校地址：{{item.address}}</p>
              </div>
              <div class="bottom">
                <p class="people" v-if="item.contacts">联系人：<b>{{item.contacts}}</b></p>
                <p class="hot-line">客服热线：<b>{{item.hotLine}}</b></p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </section>
   -->
    <section>
      <div class="kk-bottom">
        <div class="total-width">
          <h1 class="black-title" id="media">新媒体矩阵</h1>
          <ul>
            <li v-for="(item, index) in bList" :key="index">
              <img :src="item.img" alt="" />
              <p>{{ item.title }}</p>
            </li>
          </ul>
        </div>
      </div>
    </section>
  </main>
</template>
<script>
import metaInfo from '@/common/util/metaInfo'
import { networkData } from '@/common/util/data.js'
export default {
  name: 'Index',
  metaInfo: metaInfo.Network,
  data() {
    return {
      ...networkData,
      currentData: networkData.cList[0].children,
      currentDateTwo: networkData.cListTwo[0].children,
      nId: 1,
      nIdTwo: 1,
    }
  },
  methods: {
    selectHandle(id) {
      this.nId = id
      this.currentData = this.cList.find((item) => item.id === id).children
    },
    selectHandleTwo(id) {
      this.nIdTwo = id
      this.currentDateTwo = this.cListTwo.find(
        (item) => item.id === id,
      ).children
    },
    switchMainMap() {
      if (this.isNationalMap) {
        this.currentMap = require('@/assets/images/network/zlbt_hn.png')
        this.thumbnailMap = require('@/assets/images/network/qg_thumb.png')
        this.thumbnailMapHover = require('@/assets/images/network/qg_thumb_hover.png')
      } else {
        this.currentMap = require('@/assets/images/network/zlbt_qg.png')
        this.thumbnailMap = require('@/assets/images/network/hn_thumb.png')
        this.thumbnailMapHover = require('@/assets/images/network/hn_thumb_hover.png')
      }
      this.isNationalMap = !this.isNationalMap
    },
    toggleThumbnail() {
      this.isThumbActive = !this.isThumbActive
    },
  },
}
</script>
<style lang="less" scoped>
.network {
  background: #ffffff;
  .top-img {
    width: 100%;
    height: auto;
  }
  .kk-content {
    padding-top: 78px;
    margin-bottom: 50px;
    h1 {
      margin-bottom: 60px;
    }
    .wrap {
      display: flex;
      justify-content: space-between;
      .left {
        flex-wrap: wrap;
        justify-content: space-between;
        display: flex;
        width: 20%;
        height: 241px;
        li {
          width: 47%;
          height: 60px;
          margin-bottom: 20px;
          background: #f5f6f9;
          border-radius: 5px;
          text-align: center;
          line-height: 60px;
          cursor: pointer;
        }
      }
      .right {
        height: 700px !important;
        width: 78%;
        height: 100%;
        overflow-y: auto;
        flex-wrap: wrap;
        justify-content: space-between;
        align-content: baseline;
        display: flex;
        li {
          background: #f5f6f9;
          width: 49%;
          height: 192px;
          margin-bottom: 30px;
          padding: 20px 30px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          border-radius: 5px;
          .top {
            .address {
              margin-top: 18px;
            }
            > h2 {
              display: flex;
              align-items: center;
              .title_logo {
                display: inline-block;
                width: 60px;
                height: 18px;
                background-repeat: no-repeat;
                background-size: 60px 18px;
                margin-left: 6px;
              }
            }
          }
        }
      }
    }
    .n-active {
      background: #cd3324 !important;
      color: #ffffff !important;
      font-weight: bold !important;
    }
  }
  .kk-bottom {
    padding: 80px 0 60px;
    background: url('../../assets/images/network/kk-bg.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    h1 {
      margin-bottom: 60px;
    }
    ul {
      display: flex;
      justify-content: space-between;
      li {
        width: 200px;
        height: 216px;
        background: #ffffff;
        box-shadow: 0px 16px 13px -10px #f4f4f4;
        border-radius: 15px;
        padding: 20px 25px;
        text-align: center;

        img {
          width: 150px;
        }

        p {
          display: inline-block;
          text-align: center;
          margin: 10px auto;
          font-weight: bold;
          font-size: 15px !important;
        }
      }
    }
  }
}

.brand-box {
  .img {
    width: 100%;
    margin: 52px auto 0;
  }
  .img-bg {
    width: 100%;
  }
  .box-title {
    width: 220px;
    height: 56px;
    font-weight: 600;
    font-size: 40px;
    color: #333333;
    text-align: left;
    font-style: normal;
    text-transform: none;
    padding-top: 80px;
    margin-bottom: 60px;
  }
  @media screen and (max-width: 1700px) {
    .img {
      width: 80%;
      display: block;
      margin: 52px auto 0;
    }
  }
}

.map-container {
  position: relative;
  cursor: pointer;
}

.main-map {
  transition: opacity 0.3s;
}

.thumbnail-minimap {
  position: absolute;
  left: 20px;
  bottom: 20px;
  width: 190px;
  height: 190px;
  border: 1px solid rgba(255, 255, 255, 0.8);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  opacity: 0.6;
  transition: all 0.3s;
  border-radius: 15px;
}

.thumbnail-minimap.active {
  opacity: 1;
  transform: scale(1.05);
}

.thumbnail-mask {
  position: relative;
  width: 100%;
  height: 100%;
}

.thumbnail-mask img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.hover-tip {
  position: absolute;
  top: -40px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.8);
  color: #fff;
  padding: 8px 12px;
  border-radius: 4px;
  white-space: nowrap;
  font-size: 12px;
}

.arrow {
  position: absolute;
  bottom: -8px;
  left: 50%;
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 8px solid rgba(0, 0, 0, 0.8);
  transform: translateX(-50%);
}

.white-title {
  width: 160px;
  height: 56px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 40px;
  color: #ffffff;
  text-align: center;
  font-style: normal;
  text-transform: none;
  padding-top: 80px;
  margin-bottom: 90px;
}

.black-title {
  width: 360px;
  height: 56px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 40px;
  color: #333333;
  text-align: left;
  font-style: normal;
  text-transform: none;
  padding-top: 80px;
  padding-bottom: 20px;
  margin-bottom: 80px;
}
</style>
